import React, { useState } from "react";
import styled from "styled-components";

import { Wrapper, ErrorArea, ErrorMessage } from "components/TextForm";
import color from "constants/color";
import font from "constants/font";

// パーツ定義
const Textarea = styled.textarea<{
  minHeight: string;
  width: string;
  isErrorDisplay: boolean;
  disabled?: boolean;
  rows?: number;
  maxLength?: number;
}>`
  display: block;
  font-size: ${font.size14};
  box-sizing: border-box;
  width: ${({ width }) => width};
  padding: 12px 16px;
  height: 48px;
  -webkit-appearance: none;
  border: 1px solid ${({ isErrorDisplay }) => (isErrorDisplay ? color.warning : color.form.border)};
  background-color: ${({ isErrorDisplay, disabled }) =>
    isErrorDisplay ? color.attentionLight : disabled ? color.border : color.form.background};
  border-radius: 4px;
  outline: none;
  transition: 0.3s;
  min-height: ${({ minHeight }) => minHeight};
  resize: vertical;
  &:hover {
    border: 1px solid ${color.form.border};
  }
  &:focus {
    border: 1px solid ${color.text.link};
    background-color: ${color.text.linkLight};
  }
`;

export const DefaultArea = styled.div<{
  isDefaultDisplay: boolean;
  position?: "relative" | "absolute";
}>`
  display: ${({ isDefaultDisplay }) => (isDefaultDisplay ? "block" : "none")};
  position: ${(props) => props.position};
  white-space: nowrap;
  color: ${color.text.black};
  margin: 2px 0;
`;
export const DefaultMessage = styled.span`
  font-size: ${font.size12};
`;

// 本体
const TextareaForm = ({
  width = "200px",
  value = "",
  placeholder = "",
  required = false,
  readOnly = false,
  onChange = () => null,
  onBlur = () => null,
  onFocus = () => null,
  isError = false,
  errorMessage = "",
  defaultMessage,
  errorPosition = "absolute",
  minHeight = "0px",
  stopPropagation, // input時のeventの伝搬を防ぐ(主にshareEstimatePc版で使用)
  errorDisplayImmediate,
  disabled,
  rows,
  maxLength,
}: {
  width?: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  readOnly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isError?: boolean;
  errorMessage?: string;
  defaultMessage?: string;
  errorPosition?: "absolute" | "relative";
  minHeight?: string;
  stopPropagation?: boolean;
  errorDisplayImmediate?: boolean; // 即時エラーを反映
  disabled?: boolean;
  rows?: number;
  maxLength?: number;
}) => {
  const [isErrorDetectable, setIsErrorDetectable] = useState(false);

  // フォーカスが外れたらエラーを検出可能にする
  const onBlurForm = () => {
    setIsErrorDetectable(true);
    onBlur();
  };

  const errorDisplayCondition = errorDisplayImmediate ? isError : isError && isErrorDetectable;

  return (
    <Wrapper width={width}>
      <Textarea
        width={width}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlurForm}
        required={required}
        readOnly={readOnly}
        isErrorDisplay={errorDisplayCondition}
        minHeight={minHeight}
        onInput={(e) => stopPropagation && e.stopPropagation()}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
      />
      <DefaultArea isDefaultDisplay={!errorDisplayCondition} position={errorPosition}>
        <DefaultMessage>{defaultMessage}</DefaultMessage>
      </DefaultArea>
      <ErrorArea isErrorDisplay={errorDisplayCondition} position={errorPosition}>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </ErrorArea>
    </Wrapper>
  );
};

export default TextareaForm;
